"use strict";

exports.__esModule = true;
exports.StyledBadge = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const StyledBadge = _styledComponents.default.span`
    display: inline-block;
    background-color: ${({
  theme
}) => theme.colors.badge.background};
    padding: 0.25rem 0.6rem;
    border-radius: 1rem;
    color: ${({
  theme
}) => theme.colors.badge.text};
    font-size:  ${({
  theme
}) => theme.fontSizes[3]};
    font-weight:  ${({
  theme
}) => theme.fontWeights[2]};
    border: 2px solid ${({
  theme
}) => theme.colors.badge.border};
    line-height: 1;
    text-align: center;
    white-space: nowrap;
    vertical-align: baseline;
    box-sizing: border-box;
`;
exports.StyledBadge = StyledBadge;